module.exports = __webpack_public_path__ + "02_glasses_brown.355d2a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer4/02_glasses_brown.png
// module id = RljY
// module chunks = 0